<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
// import Location from '@/utils/location'
// const webTypeMap = {
//   zs: '中质追溯',
//   cus: '进出口追溯系统',
//   bj: '北京海关进出境产品质量安全追溯监管平台',
//   zaiq: '浙江省检验检疫科学技术研究院重要产品质量追溯系统',
//   ciqa: '北京华检技术服务中心定制产品追溯系统',
//   gz: '广州进出境产品质量安全追溯监管平台'
// }
export default {
  name: 'App',
  mounted() {
    document.title = '宋凰'
  }
}
</script>
